'use client';

import type { WorkspaceTaskBlockPaymentContext } from '@/cms/components/blocks/workspace/workspace-1/contracts/task-block-payment';
import type { AdminV2PaywallPopupBranchSlug } from '@/site-runtime/code-owned/paywall-branches';
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { SiteRuntimeCheckoutSurface } from '../checkout/site-runtime-checkout-login-intent';

export type SiteRuntimePricingDialogContextValue = {
  checkoutSurface: SiteRuntimeCheckoutSurface;
  conversionId?: string;
  onCheckoutCreated?: () => void;
  paywallBranchSlug?: AdminV2PaywallPopupBranchSlug;
  taskBlockPayment?: WorkspaceTaskBlockPaymentContext;
  titleOverride?: string;
};

const SiteRuntimePricingDialogContext =
  createContext<SiteRuntimePricingDialogContextValue>({
    checkoutSurface: 'standalone_page',
  });

export function SiteRuntimePricingDialogProvider({
  children,
  checkoutSurface,
  conversionId,
  onCheckoutCreated,
  paywallBranchSlug,
  taskBlockPayment,
  titleOverride,
}: SiteRuntimePricingDialogContextValue & { children: ReactNode }) {
  return (
    <SiteRuntimePricingDialogContext.Provider
      value={{
        checkoutSurface,
        conversionId,
        onCheckoutCreated,
        paywallBranchSlug,
        taskBlockPayment,
        titleOverride,
      }}
    >
      {children}
    </SiteRuntimePricingDialogContext.Provider>
  );
}

export function useSiteRuntimePricingDialogContext() {
  return useContext(SiteRuntimePricingDialogContext);
}
